<template>
  <div class="news_list">消息提醒</div>
</template>

<script>
export default {
  name: 'newsList'
}
</script>

<style lang="less" scoped></style>
